import { useLayoutEffect } from 'react'

/**
 * useDisableBodyScroll
 * For disabling the body scroll when an overlay is visible
 */
export function useDisableBodyScroll({ disable }: { disable: boolean }) {
  useLayoutEffect(() => {
    if (disable) {
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth
      document.body.style.overflow = 'hidden'
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`
      }
    } else {
      document.body.style.removeProperty('overflow')
      document.body.style.removeProperty('padding-right')
    }

    return () => {
      document.body.style.removeProperty('overflow')
      document.body.style.removeProperty('padding-right')
    }
  }, [disable])
}
